import { Title, mq } from '@kvdbil/components';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.tertiary.mainAlt};
  display: inline-block;
  padding: 0.25rem;
  min-width: 249px;
  text-align: center;

  ${mq(null, 'mobileL')} {
    min-width: 193px;
  }
`;

const Text = styled(Title)`
  color: ${({ theme }) => theme.colors.text.light};
`;

interface Props {
  children: ReactNode;
}

const Badge = ({ children }: Props) => {
  return (
    <Container>
      <Text>{children}</Text>
    </Container>
  );
};

export default Badge;
